import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

import { ErrorReaderModule } from '../../seds-form-field/pipes/error-reader/error-reader.module';
import { SedsFormFieldDropdownComponent } from './seds-form-field-dropdown.component';
import { SedsFormFieldCoreModule } from '../../seds-form-field/seds-form-field-core/seds-form-field-core.module';

@NgModule({
  declarations: [SedsFormFieldDropdownComponent],
  imports: [
    CommonModule,
    SedsFormFieldCoreModule,
    ErrorReaderModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
  ],
  exports: [SedsFormFieldDropdownComponent, MatSelectModule],
})
export class SedsFormFieldDropdownModule {}
